"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.App = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uxcore = require("@ux/uxcore2");

var _constants = require("../constants");

var _actions = require("../store/actions");

var _props = require("../props");

var _styles = _interopRequireDefault(require("../styles"));

var _Container = _interopRequireDefault(require("./Container"));

var _DraggableResizable = _interopRequireDefault(require("./DraggableResizable"));

var _Style = _interopRequireDefault(require("./Style"));

var _StyleLegacyUxcore = _interopRequireDefault(require("./StyleLegacyUxcore1"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var App =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(App, _PureComponent);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).call(this, props));
    _this.handleChangeMinimized = _this.handleChangeMinimized.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee() {
        var _this$props, minimized, opened;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, minimized = _this$props.minimized, opened = _this$props.opened;
                this.props.onChange && this.props.onChange({
                  minimized: minimized
                });

                if (!(!minimized && !opened)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 5;
                return this.props.trafficOpen({
                  external: false
                });

              case 5:
                this.props.appOpenedSet(true);

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this$props2 = this.props,
          forceMinimized = _this$props2.forceMinimized,
          minimized = _this$props2.minimized;

      if (typeof forceMinimized !== 'undefined' && minimized !== forceMinimized) {
        this.props.appMinimizedSet({
          external: true,
          minimized: forceMinimized
        });
      }
    }
  }, {
    key: "handleChangeMinimized",
    value: function handleChangeMinimized(minimized) {
      this.props.appMinimizedSet({
        external: false,
        minimized: minimized
      });
      this.props.onChange && this.props.onChange({
        minimized: minimized
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          affordance = _this$props3.affordance,
          breakpoint = _this$props3.breakpoint,
          draggable = _this$props3.draggable,
          env = _this$props3.env,
          heightInitial = _this$props3.heightInitial,
          heightMax = _this$props3.heightMax,
          heightMin = _this$props3.heightMin,
          market = _this$props3.market,
          minimized = _this$props3.minimized,
          notifications = _this$props3.notifications,
          position = _this$props3.position,
          product = _this$props3.product,
          resizable = _this$props3.resizable,
          shopperId = _this$props3.shopperId,
          showMessaging = _this$props3.showMessaging,
          standalone = _this$props3.standalone,
          tabInitial = _this$props3.tabInitial,
          welcomeIntent = _this$props3.welcomeIntent,
          widthInitial = _this$props3.widthInitial,
          widthMax = _this$props3.widthMax,
          widthMin = _this$props3.widthMin,
          zIndex = _this$props3.zIndex;
      var tabs = this.props.tabs;

      if (market !== _constants.MARKET_EN_US) {
        tabs = [_constants.TAB_BROWSE];
      }

      return _react.default.createElement(_react.Fragment, null, standalone ? _react.default.createElement(_Container.default, {
        breakpoint: breakpoint,
        draggable: draggable,
        env: env,
        handleChangeMinimized: this.handleChangeMinimized,
        market: market,
        position: position,
        product: product,
        shopperId: shopperId,
        showMessaging: showMessaging,
        standalone: standalone,
        tabInitial: tabInitial,
        tabs: tabs,
        welcomeIntent: welcomeIntent
      }) : _react.default.createElement(_react.Fragment, null, affordance && _react.default.createElement("div", {
        className: "help--affordance-bubble",
        onClick: function onClick() {
          _this2.props.appNotificationsSet(0);

          _this2.handleChangeMinimized(!minimized);
        },
        onKeyDown: null,
        role: "button",
        tabIndex: 0
      }, _react.default.createElement(_uxcore.Icon, {
        name: minimized ? 'help' : 'x',
        size: 24,
        color: "white"
      }), notifications > 0 && _react.default.createElement("div", {
        className: "help--affordance-bubble-notifications"
      }, _react.default.createElement(_uxcore.Icon, {
        name: "asterisk",
        size: 10,
        color: "white"
      }))), _react.default.createElement(_DraggableResizable.default, {
        affordance: affordance,
        breakpoint: breakpoint,
        disableDrag: !draggable,
        disableResize: !resizable,
        heightInitial: heightInitial,
        heightMax: heightMax,
        heightMin: heightMin,
        position: position,
        widthInitial: widthInitial,
        widthMax: widthMax,
        widthMin: widthMin,
        zIndex: zIndex,
        render: function render(_ref) {
          var resetPosition = _ref.resetPosition;
          return _react.default.createElement(_Container.default, {
            breakpoint: breakpoint,
            draggable: draggable,
            env: env,
            handleChangeMinimized: _this2.handleChangeMinimized,
            market: market,
            position: position,
            product: product,
            resetPosition: resetPosition,
            shopperId: shopperId,
            showMessaging: showMessaging,
            standalone: standalone,
            tabInitial: tabInitial,
            tabs: tabs,
            welcomeIntent: welcomeIntent
          });
        }
      })), _react.default.createElement(_Style.default, {
        css: "\n          .help--affordance-bubble {\n            align-items: center;\n            background-color: ".concat(_styles.default.colors.blue, ";\n            border-radius: 50%;\n            bottom: 20px;\n            box-shadow: rgba(0, 0, 0, 0.5) 0px 0px 40px;\n            cursor: pointer;\n            display: flex;\n            height: 60px;\n            justify-content: center;\n            position: fixed;\n            width: 60px;\n            z-index: ").concat(zIndex, ";\n\n            ").concat(position === _constants.POSITION_LEFT ? _constants.POSITION_LEFT : _constants.POSITION_RIGHT, ": 20px;\n          }\n          .help--affordance-bubble:focus {\n            outline: none;\n          }\n\n          .help--affordance-bubble-notifications {\n            border-radius: 50%;\n            color: white;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            font-size: 12px;\n            position: absolute;\n            top: 0;\n            right: 0;\n            width: 20px;\n            height: 20px;\n            background-color: #FD341D;\n          }\n        ")
      }), _react.default.createElement(_Style.default, {
        css: "\n          .help--is-hidden {\n            visibility: hidden;\n          }\n        "
      }), _react.default.createElement(_StyleLegacyUxcore.default, null));
    }
  }]);

  return App;
}(_react.PureComponent);

exports.App = App;
App.propTypes = {
  affordance: _props.propTypes.affordance,
  appOpenedSet: _propTypes.default.func,
  appMinimizedSet: _propTypes.default.func.isRequired,
  appNotificationsSet: _propTypes.default.func.isRequired,
  breakpoint: _props.propTypes.breakpoint,
  draggable: _props.propTypes.draggable,
  env: _props.propTypes.env,
  forceMinimized: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  heightInitial: _props.propTypes.heightInitial,
  heightMax: _props.propTypes.heightMax,
  heightMin: _props.propTypes.heightMin,
  market: _props.propTypes.market,
  minimized: _propTypes.default.bool.isRequired,
  notifications: _propTypes.default.number.isRequired,
  opened: _propTypes.default.bool,
  position: _props.propTypes.position,
  product: _props.propTypes.product,
  resizable: _props.propTypes.resizable,
  shopperId: _props.propTypes.shopperId,
  showMessaging: _props.propTypes.showMessaging,
  standalone: _props.propTypes.standalone,
  tabInitial: _props.propTypes.tabInitial,
  tabs: _props.propTypes.tabs,
  trafficOpen: _propTypes.default.func,
  welcomeIntent: _props.propTypes.welcomeIntent,
  widthInitial: _props.propTypes.widthInitial,
  widthMax: _props.propTypes.widthMax,
  widthMin: _props.propTypes.widthMin,
  zIndex: _props.propTypes.zIndex
};
App.defaultProps = {
  affordance: _props.defaultProps.affordance,
  breakpoint: _props.defaultProps.breakpoint,
  draggable: _props.defaultProps.draggable,
  env: _props.defaultProps.env,
  heightInitial: _props.defaultProps.heightInitial,
  heightMax: _props.defaultProps.heightMax,
  heightMin: _props.defaultProps.heightMin,
  market: _props.defaultProps.market,
  position: _props.defaultProps.position,
  resizable: _props.defaultProps.resizable,
  shopperId: _props.defaultProps.shopperId,
  showMessaging: _props.defaultProps.showMessaging,
  standalone: _props.defaultProps.standalone,
  tabs: _props.defaultProps.tabs,
  welcomeIntent: _props.defaultProps.welcomeIntent,
  widthInitial: _props.defaultProps.widthInitial,
  widthMax: _props.defaultProps.widthMax,
  widthMin: _props.defaultProps.widthMin,
  zIndex: _props.defaultProps.zIndex
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    minimized: state.app.minimized,
    notifications: state.app.notifications,
    opened: state.app.opened
  };
};

var mapDispatchToProps = {
  appOpenedSet: _actions.appOpenedSet,
  appMinimizedSet: _actions.appMinimizedSet,
  appNotificationsSet: _actions.appNotificationsSet,
  trafficOpen: _actions.trafficOpen
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(App);

exports.default = _default;